exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1LaiUlY70kqrnnF7k2nz1x{border-bottom:.07143rem solid #ccc;margin:1.42857rem 0 .71429rem 1.07143rem;-webkit-transition-duration:0ms;-moz-transition-duration:0ms;-o-transition-duration:0ms;transition-duration:0ms}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"InternalNotesPart_addNote": "_3MFvtIE3aB_gfvSU7GrG3e",
	"InternalNotesPart_line": "_1LaiUlY70kqrnnF7k2nz1x"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/CoveredInClass/InternalNotesPart/style.postcss
// module id = 1562
// module chunks = 0